import React from "react";
import { Avatar, Tooltip } from "antd";
import { FileImageOutlined, MenuOutlined } from "@ant-design/icons";
import VariableForms from "../forms";
import { ModalStandard, Localize } from "components/service";
import { TVariableList } from "../helpers/variable-types-helper";
import { SortableHandle } from "react-sortable-hoc";
import { usePermissionByObject, useIsDeveloper } from "components/permissions";
import VariableConst from "components/variable/variable-const";
import { localizeByKeyStatic } from "components/service/localize";

interface VariableSlugFieldProps
{
    variableList: TVariableList;
    variables: Record<string, any>;
}

const VariableSlugField: React.FC<VariableSlugFieldProps> = ({
    variableList,
    variables,
}) =>
{
    const { hasPermission: hasUpdateItemsPermission } = usePermissionByObject(VariableConst.permissions.UPDATE_ITEMS);
    const { hasPermission: hasChangeOrderPermission } = usePermissionByObject(VariableConst.permissions.CHANGE_ORDER);
    const isDeveloper = useIsDeveloper();
    const canUpdateItems = isDeveloper || hasUpdateItemsPermission;
    const canChangeOrder = isDeveloper || hasChangeOrderPermission;

    const DragHandle = SortableHandle(() => (
        <Tooltip title={!canChangeOrder ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(VariableConst.permissions.CHANGE_ORDER.slug)}` : undefined}>
            <MenuOutlined
                style={{
                    cursor: canChangeOrder ? 'grab' : 'not-allowed',
                    color: canChangeOrder ? '#999' : '#ccc',
                    padding: '15px 20px',
                    opacity: canChangeOrder ? 1 : 0.5,
                }}
            />
        </Tooltip>
    ));

    return (
        <div className="d-flex align-items-center">

            <DragHandle />

            <div style={{ minWidth: "45px" }}>
                <Avatar
                    shape="square"
                    size="small"
                    icon={
                        variableList?.img_path ? (
                            <img src={variableList?.img_path} alt="avatar" />
                        ) : (
                            <FileImageOutlined />
                        )
                    }
                />
            </div>

            <ModalStandard
                width={500}
                extraClass={"modal-form"}
                disabled={!canUpdateItems}
                modalButton={
                    <Tooltip title={!canUpdateItems ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(VariableConst.permissions.UPDATE_ITEMS.slug)}` : undefined}>
                        <strong
                            className="title"
                            style={{
                                cursor: canUpdateItems ? "pointer" : "not-allowed",
                                opacity: canUpdateItems ? 1 : 0.5,
                            }}
                        >
                            {variableList?.slug}
                        </strong>
                    </Tooltip>
                }
                modalTitle={
                    <strong className="modal-title">
                        <span className="text">
                            <Localize>FORMS.Title_EditKey</Localize>
                        </span>
                    </strong>
                }
            >
                <VariableForms.Edit
                    action={() => { }}
                    variableList={variableList}
                    variables={variables}
                />
            </ModalStandard>
        </div>
    );
};

export default VariableSlugField;
